import React from 'react';
import OrganicTrafficSplineChart from '../OrganicTrafficSplineChart';
import KeywordsWithOrganicTrafficSplineChart from '../KeywordsWithOrganicTrafficSplineChart';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { PercentTotalTrafficSplineChart } from '../../Total/PercentTotalTrafficSplineChart';
import { TrafficByTopicBarChart } from '../../TrafficByTopicBarChart';
import { TrafficAdvancedSearchBarChart } from '../../TrafficAdvancedSearchBarChart';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';
import { TrafficNoDataPlaceholder } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/Total/pages/NonTopicOrTopicGroupPage';
import { useTrafficAvailability } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/Total/hooks/useTrafficAvailability';
import OrganicTrafficGrid from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/Organic/OrganicTrafficGrid';
import { ExportConfigProvider } from 'src/components/BeaconV2Components/common/AppExportModal/ExportModalContext';

/**
 * Organic traffic page for non topic views
 */
export function NonTopicOrTopicGroupPage() {
  const mainEntityType = useMainEntityType();
  const { dataAvailable } = useTrafficAvailability();

  return (
    <ExportConfigProvider overrideShouldIntercept={true}>
      <BasePageContainer>
        {dataAvailable ? (
          <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
          <OrganicTrafficSplineChart />
          <TrafficByTopicBarChart metric="organicTraffic" />
          <TrafficAdvancedSearchBarChart metric="organicClicks" groupByField="searchTerm" />
          <KeywordsWithOrganicTrafficSplineChart />
          {!['category', 'subcategory', 'product'].includes(mainEntityType) && (
            <TrafficAdvancedSearchBarChart metric="organicClicks" groupByField="categoryId" />
          )}
          {!['subcategory', 'product'].includes(mainEntityType) && (
            <TrafficAdvancedSearchBarChart metric="organicClicks" groupByField="subCategoryId" />
          )}
          <PercentTotalTrafficSplineChart trafficType="organicTraffic" />
          <OrganicTrafficGrid />
        </Flex>
      ) : (
          <TrafficNoDataPlaceholder />
        )}
      </BasePageContainer>
    </ExportConfigProvider>
  );
}
